import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation } from "@apollo/react-hooks";
import { Box } from "@mui/material";
import { useFormik } from "formik";
import { useMyNewsEnabled } from "my-news/hooks";
import {
  OcCard,
  OcCardButtonBar,
  OcConfirmationDialog,
  OcSettingSwitch,
} from "oc/components";
import { OC_UPDATE_PROPERTY } from "oc/graphql";
import { useOcSnackbar } from "oc/hooks";

interface MyNewsSettingsCardProps {
  isMobile: boolean;
}

export const MyNewsSettingsCard = ({ isMobile }: MyNewsSettingsCardProps) => {
  const { t } = useTranslation();
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const { state: myNewsEnabled, setState: setMyNewsState } = useMyNewsEnabled();
  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,

    initialValues: {
      enabled: myNewsEnabled,
    },
    onSubmit: (values) => {
      handleSaveEnabled(values.enabled);
    },
  });

  const { setOpenMessage } = useOcSnackbar();
  const [updateProperty, { loading }] = useMutation(OC_UPDATE_PROPERTY, {
    onError({ ...err }) {
      alert("error" + err.toString());
      setOpenMessage({
        type: "error",
        message: t("OC_PROPERTY_SAVE_FAILED"),
      });
    },
    onCompleted(data) {
      if (data?.updateProperty.key === "myNewsEnabled") {
        const parsedValue = data?.updateProperty.value === "true";
        setMyNewsState(parsedValue);
      }
      setOpenMessage({
        type: "success",
        message: t("OC_PROPERTY_SAVE_SUCCEEDED"),
      });
    },
  });

  const handleSaveEnabled = (value: boolean) => {
    updateProperty({
      variables: {
        resource: "myNews",
        key: "myNewsEnabled",
        value: value.toString(),
      },
    });
    setShowConfirmDialog(false);
  };

  const handleCancel = () => {
    formik.resetForm();
  };

  const handleOpendialog = () => {
    setShowConfirmDialog(true);
  };

  const handleDialogCancel = () => {
    setShowConfirmDialog(false);
  };

  return (
    <>
      <OcConfirmationDialog
        showDialog={showConfirmDialog}
        onClose={() => {
          formik.handleSubmit();
        }}
        onCancel={handleDialogCancel}
        title={t("OC_CONFIRM_SETTING")}
        texts={[t("OC_CONFIRM_SETTING_INFO")]}
        okButtonText={t("OC_ALL_RIGHT")}
        cancelButtonText={t("OC_CANCEL")}
      />
      <OcCard label={t("OC_GENERAL_SETTINGS")} loading={loading}>
        <Box height="10px" />
        <OcSettingSwitch
          id="enabled"
          label={"MyNews"}
          info={t("MY_NEWS_MENU_ALLOWED_INFO")}
          value={formik.values.enabled}
          onChange={formik.handleChange}
          isMobile={isMobile}
          disabled={false}
        />
        <OcCardButtonBar
          handleRightButton={handleCancel}
          rightButtonText={t("OC_CANCEL")}
          rightButtonColor="secondary"
          handlePrimaryButton={handleOpendialog}
          primaryButtonText={t("OC_SAVE")}
          primaryButtonDisabled={
            loading || myNewsEnabled === formik.values.enabled
          }
        />
      </OcCard>
    </>
  );
};

export default MyNewsSettingsCard;
